import { GraphVizNodeComponentType } from '@/modules/graphViz/graphVizNodeConfig';
import { formatCurrency } from '@/utils/formatting/currency';

import { EstateWaterfall_TaxSummaryV2Fragment } from '../graphql/EstateWaterfall.generated';
import { useTaxBreakout } from '../hooks/useTaxBreakout';

export interface TaxLineThreeProps {
  summary: EstateWaterfall_TaxSummaryV2Fragment;
}

export const TaxLineThree = ({ summary }: TaxLineThreeProps) => {
  const {
    showTaxBreakout,
    node,
    federal,
    stateTaxesByCode,
    inheritanceTaxesByCode,
  } = useTaxBreakout(summary);

  if (
    !showTaxBreakout ||
    node.data.componentType !== GraphVizNodeComponentType.TileIcon
  ) {
    return null;
  }

  const states = Object.entries(stateTaxesByCode).flatMap(
    ([stateCode, tax]) => {
      return tax.greaterThan(0)
        ? [`${stateCode} ${formatCurrency(tax, { notation: 'compact' })}`]
        : [];
    }
  );

  const inheritanceStates = Object.entries(inheritanceTaxesByCode).flatMap(
    ([stateCode, tax]) => {
      return tax.greaterThan(0)
        ? [
            `${stateCode} Inheritance ${formatCurrency(tax, { notation: 'compact' })}`,
          ]
        : [];
    }
  );

  const taxCopy = [
    ...(federal.greaterThan(0)
      ? [`Federal ${formatCurrency(federal, { notation: 'compact' })}`]
      : []),
    ...states,
    ...inheritanceStates,
  ]
    .filter(Boolean)
    .join(' & ');

  return <>{taxCopy}</>;
};
